import { executeCode } from '@helpers'
import { FIELD_BIND_TYPE_ENUM } from '@constants'
import { MapPointGroup, ObjectDataRecord } from '@types'

/**
 * Вычисляет текст подписи для точки на карте на основе конфигурации группы и данных объекта.
 *
 * Сейчас поддерживается только bindType FIELD_BIND_TYPE_ENUM.JS:
 * - value содержит JavaScript-код
 * - код исполняется через executeCode с контекстом { srcObj }
 */
export const getPointLabel = (
  group: MapPointGroup,
  record: ObjectDataRecord
): string | undefined => {
  const label = group.label

  if (!label) {
    return undefined
  }

  switch (label.bindType) {
    case FIELD_BIND_TYPE_ENUM.JS: {
      const result = executeCode(label.value, {
        srcObj: record,
      })

      if (result === false || result === null || result === undefined) {
        return undefined
      }

      const text = String(result).trim()

      return text.length ? text : undefined
    }

    // Зарезервировано под будущие типы (FIELD, STATIC и т.п.)
    default:
      return undefined
  }
}
